import {
  Columns,
  CommonDataTableFields,
  TableColumnType,
  TableDataType,
  TableRow,
} from 'common/components/data-table/types';
import {PropertyType} from 'common/report/constants';
import {getMedianFormatter} from 'common/report/funnels/models/time-to-convert/utils';
import {FunnelBookmark, FunnelMedianDataSegment} from 'common/report/funnels/models/types';
import {getSegmentColumnSpecs} from 'common/report/funnels/util';

export function getDataTableColumns(bookmark: FunnelBookmark, hasTimeComparison: boolean): Columns {
  let segmentColumns = getSegmentColumnSpecs(bookmark);
  segmentColumns = segmentColumns.length ? segmentColumns : [{title: `Overall`, segmentType: PropertyType.String}];

  const columns: Columns = segmentColumns.map(({title, segmentType}, idx) => ({
    field: `${CommonDataTableFields.SegmentPrefix}${idx}`,
    type: TableColumnType.Segment,
    contentType: segmentType,
    title,
    sticky: true,
    isSortable: true,
  }));

  const cellRenderer = ({item, context}) => {
    return getMedianFormatter(parseInt(item[context.field]));
  };

  columns.push({
    field: CommonDataTableFields.Total,
    type: TableColumnType.Data,
    contentType: TableDataType.Number,
    title: `Median Time to Convert`,
    cellRenderer,
    isSortable: true,
    sticky: true,
    sortSelectTitle: `Value`,
  });

  if (hasTimeComparison) {
    columns.push({
      field: CommonDataTableFields.TimeComparisonTotal,
      type: TableColumnType.Data,
      contentType: TableDataType.Number,
      title: `Median Time to Convert (Past)`,
      cellRenderer,
      isSortable: true,
      sticky: true,
    });
  }

  return columns;
}

export function getDataTableRows(segments: FunnelMedianDataSegment[]): TableRow[] {
  return segments.map((segment) => {
    const segmentValueMap = Object.fromEntries(
      segment.props.map((prop, idx) => [`${CommonDataTableFields.SegmentPrefix}${idx}`, prop]),
    );

    return {
      ...segmentValueMap,
      identifier: segment.prop,
      [CommonDataTableFields.Total]: segment.value,
      ...(segment.comparisonValue ? {[CommonDataTableFields.TimeComparisonTotal]: segment.comparisonValue} : {}),
    };
  });
}
